import React, { useEffect, useRef, useState } from "react";
import { checklist, upload_files } from "../api";
// import { Buffer } from "buffer";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "react-loading-screen";
import { toast } from "react-toastify";

const Upload = () => {
  // const [file, setFile] = useState(true);
  const [inputFiles, setInputFiles] = useState("");
  const fileInputRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [allchecklist, setAllCheckList] = useState([]);
  const [selectedlist, setSelectedList] = useState([]);
  const [encrypted, setencrypted] = useState("");
  const [expandedcategory, setExpandedCategory] = useState(1);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    let getlist = async () => {
      try {
        let result = await checklist();
        if (result) {
          setLoading(false);
          setAllCheckList(result.data.check_list);
          setCategory(result.data.category);
        } else {
          toast.error("Problem fetching data, Please inform Dev team");
        }
      } catch (e) {
        toast.error(e);
      }
    };
    getlist();
  }, []);

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true); // Highlight the area when dragging files
  };

  const handleDragLeave = () => {
    setDragging(false); // Remove highlight when leaving
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false); // Remove highlight when dropping files
    const files = e.dataTransfer.files;
    handleFiles(files); // Handle dropped files
  };

  const handleFiles = (files) => {
    // const fileslist = Array.from(files);
    // setInputFiles((prev) => [...prev, ...fileslist]);
    if (files) {
      // console.log(files[0]);

      const reader = new FileReader();

      reader.readAsDataURL(files[0]);

      reader.onloadend = () => {
        setencrypted(reader.result);
      };

      // let encoded = Buffer.from(files[0], "base64");

      setInputFiles(files);
      startUploadSimulation();
    }
  };

  const handleClick = () => {
    fileInputRef.current.click(); // Trigger file input click
  };

  const startUploadSimulation = () => {
    setIsUploading(true);
    setUploadPercentage(0);

    const interval = setInterval(() => {
      setUploadPercentage((prevPercentage) => {
        if (prevPercentage >= 100) {
          clearInterval(interval);
          setIsUploading(false);
          return 100; // Ensure it stays at 100% after completion
        }
        return prevPercentage + 10; // Increase by 10% for demo purposes
      });
    }, 100); // Increase the percentage every 100ms
  };

  const handlecheck = (id) => {
    if (id === true || id === false) {
      if (id === true) {
        setSelectedList(allchecklist.map((e) => e.id));
        setExpandedCategory("1");
      } else {
        setSelectedList([]);
      }
    } else {
      if (selectedlist.indexOf(id) >= 0) {
        setSelectedList(selectedlist.filter((item) => item !== id));
      } else {
        setSelectedList([...selectedlist, id]);
      }
    }
  };

  const handleSubmit = async () => {
    if (selectedlist.length === 0) {
      toast.info("Please select atleast one option in checklist");
      return;
    } else {
      if (inputFiles) {
        toast.info("uploading file please wait ...", { autoClose: false });
        let result = await upload_files(
          encrypted,
          inputFiles[0].name,
          selectedlist
        );
        if (result.data) {
          toast.dismiss();
          toast.success("File uploaded successfully");
          navigate("/filehistory");
        } else {
          toast.dismiss();
          let error = result.error.message;
          toast.error(error);
        }
      } else {
        // alert("Please select file first");
        toast.info("Please select file to proceed");
      }
    }
  };

  // const category = [
  //   { category: "1", value: "REFERENCE RELATED REPORTING" },
  //   { category: "2", value: "STATEMENTS AND FLOATS" },
  //   { category: "3", value: "AUTHOR REPORTING" },
  //   { category: "4", value: "CONTENT REPORTING" },
  //   { category: "5", value: "INTEGRITY RELATED REPORTING" },
  // ];

  const groupedChecklist =
    allchecklist &&
    allchecklist.length > 0 &&
    allchecklist.reduce((groups, item) => {
      if (!groups[item.catagory]) {
        groups[item.catagory] = [];
      }
      groups[item.catagory].push(item);
      return groups;
    }, {});

  const toggleCategory = (id) => {
    if (expandedcategory === id) {
      setExpandedCategory("-1");
    } else {
      setExpandedCategory(id);
    }
  };

  return (
    <div className="w-full p-10 flex flex-col">
      <LoadingScreen
        loading={loading}
        bgColor="#f1f1f1"
        spinnerColor="#9ee5f8"
        textColor="#676767"
        // logoSrc="/logo.png"
        text="Fetching Data please wait"
      >
        <div className="flex flex-col md:flex-row w-full gap-10 md:gap-0">
          <div className="w-full md:w-6/12 flex justify-center mt-16">
            <div className="w-full h-fit border-[1px] border-C4C6CC py-[42px] px-10 rounded-[24px]">
              <div
                className={`w-full border-[1px] border-dashed border-C4C6CC px-[8.681vw] py-[50px] flex flex-col items-center justify-center rounded-[12px] ${
                  dragging ? "bg-222222" : "bg-F6F6F6"
                }`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <div>
                  <img
                    src={process.env.PUBLIC_URL + "/images/upload/file 1.png"}
                    alt="file_upload_img"
                  />
                </div>
                {dragging ? (
                  <div className="flex">
                    <p className="text-white">Drop your files here</p>
                  </div>
                ) : (
                  <>
                    <div className="flex gap-1 mt-12 flex-wrap justify-center">
                      <p className="text-18 text-154A79 font-medium">
                        Drag and Drop file here or
                      </p>
                      <button
                        onClick={handleClick}
                        className="text-18 text-154A79 font-semibold underline underline-offset-2"
                      >
                        Choose file
                      </button>
                      <input
                        type="file"
                        name="project_name"
                        placeholder="Enter Project Name"
                        ref={fileInputRef}
                        style={{ display: "none" }} // hide the file input
                        multiple
                        onChange={(e) => handleFiles(e.target.files)}
                        accept=".doc, .docx, .tex"
                      />
                    </div>
                    <div className="mt-3">
                      <p className="text-8C8A9B">
                        Supported formats: Word / Tex file
                      </p>
                    </div>
                  </>
                )}
              </div>
              {inputFiles && (
                <div className="p-6 border-[1px] border-C4C6CC mt-6 rounded-[12px] bg-F8F9FA">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center justify-between gap-4">
                      <span className="w-8 h-8">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/upload/word.png"
                          }
                          className="w-full h-full object-cover"
                          alt="Doc"
                        ></img>
                      </span>
                      <div className="flex flex-col items-start">
                        <p>
                          {inputFiles[0] !== undefined
                            ? inputFiles[0].name
                            : ""}
                        </p>
                        <p className="text-8C8A9B">
                          {inputFiles[0] !== undefined
                            ? inputFiles[0].size < 1000000
                              ? (inputFiles[0].size / 1024).toFixed(2)
                              : inputFiles[0].size
                            : ""}{" "}
                          {inputFiles[0] !== undefined
                            ? inputFiles[0].size < 1000000
                              ? "kb"
                              : "mb"
                            : ""}
                        </p>
                      </div>
                    </div>
                    <div>
                      <button onClick={() => setInputFiles("")}>
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/upload/cross.png"
                          }
                          alt="close"
                        />
                      </button>
                    </div>
                  </div>
                  <div className="w-full flex items-center mt-5 gap-2 justify-between">
                    <div className=" h-2 rounded-[12px] bg-white relative z-0 w-[95%] flex items-center">
                      <div
                        className="absolute top-0 left-0 bg-FEB13F h-2 rounded-[12px]"
                        style={{ width: `${uploadPercentage}%` }}
                      ></div>
                    </div>
                    <p className="text-8C8A9B">{uploadPercentage}%</p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="w-full md:w-6/12 px-10">
            <div className="flex flex-col h-[420px] ">
              <h1 className="text-left text-154A79 font-semibold text-24">
                Select option to check
              </h1>
              <div className="w-full mt-10 overflow-auto border-[1px] border-C4C8CC">
                <div className="w-full border-[1px] border-1px border-C4C8CC pb-5">
                  <div className="sticky top-0 flex border-b-[1px] border-C4C8CC bg-white">
                    <div className=" w-full p-4 bg-white flex">
                      {/* <p className="w-[15%]">S.No</p> */}
                      <p className="w-[80%] text-left">Title</p>
                      <div className="w-[25%] flex items-center justify-end">
                        Select All{" "}
                        <span className="ml-2 flex items-center">
                          <input
                            type="checkbox"
                            className="h-[16px] w-[16px] rounded-[6px]"
                            onChange={(e) => handlecheck(e.target.checked)}
                            checked={
                              selectedlist &&
                              selectedlist.length > 0 &&
                              selectedlist.length === allchecklist.length
                                ? true
                                : false
                            }
                          />
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                  <div>
                    {category && allchecklist && allchecklist.length > 0
                      ? category.map((value, i) => (
                          <div key={i}>
                            <div
                              className="cursor-pointer font-bold h-10 text-left p-4 flex justify-between border-[1px] border-gray py-5 items-center"
                              onClick={() => toggleCategory(value.category)}
                            >
                              <div>
                                <p>{value.value}</p>
                              </div>
                              <div>
                                {expandedcategory === value.category ? (
                                  <p>-</p>
                                ) : (
                                  <p>+</p>
                                )}
                              </div>
                            </div>
                            {expandedcategory === value.category
                              ? groupedChecklist[expandedcategory].map(
                                  (list, i) => (
                                    <div
                                      key={i}
                                      className="flex w-[97%] pl-8 pr-4 py-2"
                                    >
                                      <p className="w-[15%]">{i + 1}</p>
                                      <p className="w-[60%] text-left flex w-full gap-4">
                                        {list.title}
                                        <span className="flex items-center">
                                          <img
                                            src={
                                              process.env.PUBLIC_URL +
                                              "/images/upload/info-circle.svg"
                                            }
                                            className="h-4 w-4 cursor-pointer"
                                            alt="desc"
                                            title={list.desc}
                                          />
                                        </span>
                                      </p>
                                      <p className="w-[25%] flex justify-end">
                                        <span className="ml-2 flex w-full justify-end ">
                                          <input
                                            id={list.id}
                                            type="checkbox"
                                            value={list.title}
                                            className="h-[16px] w-[16px] rounded-[6px]"
                                            onChange={() =>
                                              handlecheck(list.id)
                                            }
                                            checked={
                                              selectedlist.indexOf(list.id) > -1
                                                ? true
                                                : false
                                            }
                                          />
                                        </span>{" "}
                                      </p>
                                    </div>
                                  )
                                )
                              : ""}
                          </div>
                        ))
                      : "No Checklist to Show"}
                    {/* {allchecklist
                    ? allchecklist.map((list, i) => (
                        <tr key={i}>
                          <td className="w-[15%]">{i + 1}</td>
                          <td className="w-[60%] text-left flex w-full gap-4">
                            {list.title}
                            <span className="flex items-center">
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/images/upload/info-circle.svg"
                                }
                                className="h-4 w-4 cursor-pointer"
                                alt="desc"
                                title={list.desc}
                              />
                            </span>
                          </td>
                          <td className="w-[25%] ">
                            <span className="ml-2 flex w-full justify-end pr-6">
                              <input
                                id={list.id}
                                type="checkbox"
                                value={list.title}
                                className="h-[16px] w-[16px] rounded-[6px]"
                                onChange={() => handlecheck(list.id)}
                                checked={
                                  selectedlist.indexOf(list.id) > -1
                                    ? true
                                    : false
                                }
                              />
                            </span>{" "}
                          </td>
                        </tr>
                      ))
                    : ""} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex justify-end">
          <button
            onClick={handleSubmit}
            className="w-[126px] h-[46px] my-[60px] rounded-[36px] bg-E63946 text-white font-semibold"
          >
            Submit
          </button>
        </div>
      </LoadingScreen>
    </div>
  );
};

export default Upload;
